import request from '@/utils/request'

export function prizeInfo (query) {
  return request({
    url: '/lucky/info',
    method: 'get',
    params: query
  })
}

export function lottery (query) {
  return request({
    url: '/lucky/lottery',
    method: 'get',
    params: query
  })
}

export function tprizeInfo (query) {
  return request({
    url: '/lucky/tinfo',
    method: 'get',
    params: query
  })
}

export function tlottery (query) {
  return request({
    url: '/lucky/tlottery',
    method: 'get',
    params: query
  })
}

export function tReceive (query) {
  return request({
    url: '/lucky/tReceive',
    method: 'get',
    params: query
  })
}